import React from 'react';

function getIssueDescription(fix) {
  if (fix.keyword) {
    return `Consider adding the keyword "${fix.keyword}" to strengthen ATS matching.`;
  }
  if (fix.section) {
    return `Suggested improvement for ${fix.section}.`;
  }
  return 'Suggested improvement.';
}

const SuggestionCard = ({ fix, isApplied, onAccept, onDismiss }) => {
  const section = fix.section || 'General';
  const issue = getIssueDescription(fix);
  const original = fix.original || '';
  const suggestion = fix.suggestion || fix.rewrite || '';

  return (
    <div className={`suggestion-card ${isApplied ? 'suggestion-card--applied' : ''}`}>
      <div className="suggestion-section-label">{section}</div>
      <p className="suggestion-issue">{issue}</p>

      {(original || suggestion) && (
        <div className="suggestion-diff">
          {original && (
            <div className="diff-old">
              <span className="diff-badge diff-badge--old">before</span>
              <span className="diff-text diff-text--old">{original}</span>
            </div>
          )}
          {suggestion && (
            <div className="diff-new">
              <span className="diff-badge diff-badge--new">after</span>
              <span className="diff-text diff-text--new">{suggestion}</span>
            </div>
          )}
        </div>
      )}

      <div className="suggestion-actions">
        <button
          className="suggestion-btn suggestion-btn--accept"
          onClick={onAccept}
          disabled={isApplied}
        >
          {isApplied ? '✓ Applied' : 'Accept'}
        </button>
        <button
          className="suggestion-btn suggestion-btn--dismiss"
          onClick={onDismiss}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
};

export default SuggestionCard;
